<template>
  <Legacy
    view="invoicing"
    action="importInvoices"
  />
</template>

<script>
import InvoiceImportDialog from '@/components/Application/Billing/Invoices/InvoiceImportDialog'
import Legacy from '@/components/Application/Legacy'
import Vue from 'vue'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      breadcrumb: {
        name: 'Carrier Invoices',
        route: { name: 'billing-carrier' }
      },
      actions: [
        {
          name: 'Import',
          icon: ['fal', 'plus'],
          event: this.createImport
        }
      ],
      invoiceImportDialogVisible: false,
      invoiceImportDialogInstance: undefined
    }
  },
  watch: {
    invoiceImportDialogVisible (visible) {
      if (!visible && typeof this.invoiceImportDialogInstance !== 'undefined') {
        this.invoiceImportDialogInstance.$destroy()
        this.invoiceImportDialogInstance.$el.remove()
        this.invoiceImportDialogInstance = undefined
      }
    }
  },
  methods: {
    createImport () {
      const InvoiceImportDialogClass = Vue.extend(InvoiceImportDialog)

      this.invoiceImportDialogInstance = new InvoiceImportDialogClass()

      this
        .invoiceImportDialogInstance
        .$on('destroy', () => {
          this.invoiceImportDialogVisible = false
        })

      this
        .invoiceImportDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.invoiceImportDialogInstance.$el)

      this.invoiceImportDialogVisible = true
    }
  }
}
</script>
